var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"typewriter"},[_c('div',{staticClass:"slide"},[_c('i')]),_c('div',{staticClass:"paper"}),_c('div',{staticClass:"keyboard"})])
}]

export { render, staticRenderFns }